import {prop} from "ramda";

import getWidgetByName from "../requests";

const getMasthead = () => getWidgetByName("mastheadpanel").then(prop('stories'));

export { getMasthead };
